import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Idioma',
  path: '/pessoal/pesidioma',
  name: 'pesidioma',
  component: () => import('@/views/pessoal/pesidioma/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.IDIOMANOVO_MENU_1400800499],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Idioma',
  path: '/pessoal/pesidioma/cadastro/:id?',
  parent: 'pesidioma',
  name: 'pesidioma_create',
  component: () => import('@/views/pessoal/pesidioma/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.IDIOMANOVO_MENU_1400800499],
  },
  goesToMenu: true,
 },
]
